module.exports = __webpack_public_path__ + "static/media/IMG_2255.68686e8e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/hneda/IMG_2255.JPG
// module id = 88
// module chunks = 0